"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Select = require("./Select.style");
/* eslint-disable jsx-a11y/label-has-associated-control */


var Select = function Select(_ref) {
  var label = _ref.label,
      name = _ref.name,
      element = _ref.element,
      items = _ref.items,
      onChangeCallback = _ref.onChangeCallback,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, ["label", "name", "element", "items", "onChangeCallback", "placeholder"]);

  var disabled = placeholder.disabled,
      hidden = placeholder.hidden,
      intro = placeholder.intro,
      placeholderValue = placeholder.placeholderValue;

  var _ref2 = (0, _react.useState)(element.value),
      _ref3 = _slicedToArray(_ref2, 2),
      currentValue = _ref3[0],
      setCurrentValue = _ref3[1];

  (0, _react.useEffect)(function () {
    setCurrentValue((element === null || element === void 0 ? void 0 : element.value) || '');
  }, [element]);

  var handleOnChange = function handleOnChange(value, selectName) {
    setCurrentValue(value);
    onChangeCallback(value, selectName);
  }; // Check if placeholder exists


  var isPlaceholder = !(Object.keys(placeholder).length === 0);
  return /*#__PURE__*/_react.default.createElement(_Select.SelectWrapper, null, /*#__PURE__*/_react.default.createElement(_Select.SelectLabel, {
    htmlFor: name
  }, label), /*#__PURE__*/_react.default.createElement(_Select.SelectElement, Object.assign({
    name: name,
    id: name,
    onChange: function onChange(e) {
      return handleOnChange(e.target.value, name);
    },
    value: currentValue
  }, rest), isPlaceholder && intro && /*#__PURE__*/_react.default.createElement("option", {
    value: placeholderValue,
    disabled: disabled,
    hidden: hidden
  }, intro), items.length > 0 && items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: item.value,
      value: item.value
    }, item.label);
  })));
};

Select.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  element: _propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.string
  }),
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.string
  })),
  onChangeCallback: _propTypes.default.func,
  placeholder: _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    hidden: _propTypes.default.bool,
    intro: _propTypes.default.string,
    placeholderValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })
};
Select.defaultProps = {
  name: '',
  label: '',
  element: {
    value: '',
    label: ''
  },
  items: [],
  onChangeCallback: function onChangeCallback() {},
  placeholder: {
    disabled: false,
    hidden: false,
    string: 'Select an option',
    placeholderValue: ''
  }
};
var _default = Select;
exports.default = _default;